__turbopack_context__.v({
  "button": "A717rq_button",
  "liked": "A717rq_liked",
  "subItem": "A717rq_subItem",
});
